<div class="description-container">
  <div class="inspection-description" #descriptionText (click)="onTemplateDescriptionModal()">
    <ng-container *ngIf="!!description?.trim(); else placeholderTxt">
      <span class="description">{{ description }}</span>
    </ng-container>
    <ng-template #placeholderTxt>
      <span class="placeholder-txt">A really thoughtful description that you haven't thought about yet...</span>
    </ng-template>
  </div>
  <span class="show-more" (click)="onTemplateDescriptionModal()" *ngIf="isOverflowing">Show more</span>
</div>
